
import { createApp } from 'vue' // import a function

import './registerServiceWorker'
import App from './App.vue'
import store from "./store";
import router from "./router";
// import { createWebHashHistory, createRouter } from "vue-router";
import axios from 'axios';

// import * as Sentry from "@sentry/vue";
// import { Integrations } from "@sentry/tracing";

import '@/assets/css/tailwind.css'
import "@/assets/fonts/fonts.css";

import i18n from "@/locales";
// import { resolve } from 'core-js/fn/promise';

// import i18n from './locales/i18n'

const app = createApp(App);

// Sentry.init({
//   app,
//   environment: process.env.NODE_ENV,
//   dsn: "https://05c98c6723794e8694e880d151738eae@o1069550.ingest.sentry.io/6064510",
//   integrations: [
//     new Integrations.BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracingOrigins: ["localhost", "grondwetloop-app.acceptatie-prodemos.nl", "grondwetloop-app.prodemos.nl", /^\//],
//     }),
//   ],
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 0,
// });




// BVB 20-05-2025 maintain access to vuex store in vue3
app.config.globalProperties.$store = store;
app.config.globalProperties.$location = null;

var retrievingGPSLocation = null;

function getGPSLocation() {
  console.log(' == get GPS location ==');
  retrievingGPSLocation = true;
  navigator.geolocation.getCurrentPosition((location) => {

        // activate the gps already
        console.log("got location!")
        console.log(location)
        // save it globally
        app.config.globalProperties.$gpslocation = location;
  },
  (error) => {
      console.log(error);
      retrievingGPSLocation = false;
  });  
}

async function loadSettings() {
  console.log("== load settings ==");
  try {
    const response = await axios.get("/static/content/settings.json?ts=" + Date.now());

    const defaults = {
      points_per_question: response.data.pointsPerQuestion,
      game_duration: response.data.defaulttime,
      endgame_duration: response.data.endgametime,
      endgame_playertime: response.data.endgameplayertime,
      hitdistance: response.data.hitdistance,
      markerpool: response.data.markerpool,
      mapprovider: response.data.mapprovider,
    };

    store.dispatch("gamesettings/defaults", defaults);
    store.dispatch("setMasterCode", response.data.code);
    store.dispatch("setInitialised", true);
  } catch (error) {
    console.error("Fout bij laden van settings:", error);
    throw error; 
  }
}

async function loadLocations() {
  console.log("== load locations ==");
  try {
    const response = await axios.get("/static/content/questions/locations.json?ts=" + Date.now());

    const defaults = {
      question_locations: response.data.locations,
      endgame_locations: response.data.endgame_locations,
      selectable_rounds : response.data.rounds,
      selectable_levels : response.data.levels
    };

    store.dispatch("gamesettings/init", defaults);
  } catch (error) {
    console.error("Fout bij laden van locations:", error);
    throw error; 
  }
}

router.beforeEach(async (to,from) => {
  // BVB 03072025 retrieve GPS location and load settings when we do not have them 
  // if (to.name === "SetupUserType" || to.name === "SetupFromVWNW"){
  if (process.env.NODE_ENV === 'development') {
    console.log(from);
    console.log(to);
  }
  if (!app.config.globalProperties.$gpslocation && !retrievingGPSLocation) {
    getGPSLocation();
  }

  if (!store.getters.initialised) {
    try {
      await Promise.all([loadLocations(), loadSettings()]);
    } catch (e) {
      console.error("Initialization failed", e);
      // Optionally show user error feedback here
    }
  }
})

app.use(store);
app.use(router);
app.use(i18n);

// app.mount('#app');
// Replace -> app.mount('#app')
router.isReady().then(() => {
  app.mount('#app')
})
